import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, GlobeIcon, LibraryIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, SunIcon } from 'lucide-react';
import { MOCKUP_URL, heroTestimonials as heroQuotes } from '../data/content';
const chips = [{
  icon: ZapIcon,
  label: 'Acceso en 5 min',
  short: '5 min'
}, {
  icon: GlobeIcon,
  label: 'España y Latinoamérica',
  short: 'ES + LATAM'
}, {
  icon: LibraryIcon,
  label: '5 Tomos + 5 Bonos',
  short: '5 + 5'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Tarjeta de débito o crédito'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
const stats = [{
  value: '+1.200',
  label: 'familias hispanohablantes'
}, {
  value: '5',
  label: 'Tomos listos'
}, {
  value: '5',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink-950 pb-16 pt-5 sm:pt-14" data-id="element-119" data-mp="384jud2bfbpui">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-120" data-mp="3j9ah3d0igq55">
        <p className="font-display text-[11px] font-700 uppercase tracking-[0.28em] text-gold" style={{
        fontSize: "12px"
      }} data-id="element-121" data-mp="3o6u697yqynbv">
          ☀ KODA DIGITAL
        </p>

        <p className="mt-4 font-display text-lg font-800 leading-snug text-white sm:mt-6 sm:text-2xl" style={{
        fontSize: "24px",
        color: "#F2B41C"
      }} data-id="element-122" data-mp="3e84n7bv46wu1">
          ¿Querés llevar tu factura de luz a cero?
        </p>

        <h1 className="mt-2 font-display text-4xl font-900 leading-[1.04] tracking-tight text-white sm:mt-3 sm:text-5xl lg:text-[3.4rem]" style={{
        fontSize: "24px",
        textAlign: "center",
        backgroundColor: "#000000",
        color: "#FFFFFF"
      }} data-id="element-123" data-mp="35akmc415z2jy">
          Todo lo que necesitas saber antes de instalar paneles solares
          <span className="block text-gold" style={{
          fontSize: "20px"
        }} data-id="element-124" data-mp="2ll0i76w0uii9">
</span>
        </h1>
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-4 w-full max-w-[340px] sm:mt-6 sm:max-w-[560px]" data-id="element-125" data-mp="s2tenov66frb">
          <img src={`${MOCKUP_URL}?width=560&quality=65&format=webp`} srcSet={`${MOCKUP_URL}?width=320&quality=65&format=webp 320w, ${MOCKUP_URL}?width=560&quality=65&format=webp 560w, ${MOCKUP_URL}?width=840&quality=65&format=webp 840w`} sizes="(min-width: 640px) 560px, 340px" alt="Pack completo El Código Solar 360°: caja del sistema, 5 tomos y los bonos incluidos" className="h-auto w-full rounded-xl object-contain" width={560} height={373} fetchPriority="high" decoding="async" data-id="element-126" data-mp="ddwwv03b9odi" />
        </motion.div>

        <p className="mt-3 max-w-2xl text-lg leading-relaxed text-slate-300 sm:mt-5" style={{
        fontSize: "18px",
        fontWeight: "400",
        fontFamily: "Avenir, sans-serif"
      }} data-id="element-127" data-mp="3lu04j5ufbd1u">
          Evaluá cualquier presupuesto solar sin ser técnico, y controlá cada número de tu instalación para no pagar de más
        </p>

        

        

        
      </div>

      <div className="mx-auto mt-12 w-full max-w-6xl px-4 sm:px-6" style={{
      paddingTop: "0px",
      paddingBottom: "0px",
      marginTop: "0px",
      marginBottom: "0px"
    }} data-id="element-128" data-mp="26a96xcjm0wrz">
        <dl className="grid grid-cols-2 gap-x-6 gap-y-5 border-y border-ink-800 py-6 text-center sm:grid-cols-4" style={{
        paddingTop: "0px",
        paddingBottom: "0px"
      }} data-id="element-129" data-mp="2fzstas6j78rl">
          {stats.map(stat => <div key={stat.label} data-id="element-130" data-mp="2p0qpwpen4e05">
              <dt className="sr-only" data-id="element-131" data-mp="2p1sc9q13wmx6">{stat.label}</dt>
              <dd data-id="element-132" data-mp="2tzlj8la8hkyi">
                <span className="block font-display text-2xl font-800 text-white" data-id="element-133" data-mp="2tztu67msqg72">
                  {stat.value}
                </span>
                <span className="mt-0.5 block text-xs leading-snug text-slate-400" data-id="element-134" data-mp="uo0we8s6p6ta">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <ul className="mt-10 grid gap-3 md:grid-cols-3" data-id="element-135" data-mp="4a2tfh4nx3y1">
          {heroQuotes.map(item => <li key={item.name} className="flex flex-col rounded-xl border border-ink-800 bg-ink-900 p-5" data-id="element-136" data-mp="3vigsajh2h24n">
              <p className="text-xs tracking-widest text-gold" aria-label="5 de 5 estrellas" data-id="element-137" data-mp="e8in9rv2qrb8">
                ★★★★★
              </p>
              <p className="mt-2 text-[15px] leading-relaxed text-slate-200" data-id="element-138" data-mp="98e3nsyvdggs">“{item.quote}”</p>
              <p className="mt-auto flex items-center gap-2 pt-4 text-xs text-slate-400" data-id="element-139" data-mp="3hqk3opelxad0">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-ink-700 font-display text-[11px] font-700 text-gold" data-id="element-140" data-mp="3ct0nhjycmnif">
                  {item.initials}
                </span>
                {item.name} · {item.city}
              </p>
            </li>)}
        </ul>
      </div>
    </header>;
}